<template>
  <el-dialog
      :visible.sync="callStatBlockVisible"
      width="85%"
      title="Информация по звонкам"
      class="calls-stats-dialog"
  >
    <div>
      <div class="calls-stat-block">
        <div class="calls-stat-block__period">
          <my-date-period-picker :getTime="getStartEndTimeForGetCategoryCalls"/>
          <div>
            <my-button @click="getCallsStat" v-loading="buttonLoading">Показать</my-button>
            <my-button @click="getCallsStatExcel"  v-loading="buttonLoading">Сформировать файл</my-button>
          </div>
        </div>

        <div class="calls-stat-block__body" v-if="callStatData.general">
          <div>
            <h5>Полная информация</h5>
            <el-row>
              <el-col>
                <el-card shadow="hover" class="stat-card">
                  <el-statistic
                      title="Всего минут"
                      effect="dark"
                      :value="animatedGeneral.allSec"
                  >
                    <template slot="formatter">
                      {{ formatNumber(animatedGeneral.allSec) }}
                    </template>
                  </el-statistic>
                </el-card>
              </el-col>
              <el-col>
                <el-card shadow="hover" class="stat-card">
                  <el-statistic
                      title="Всего звонков"
                      :value="animatedGeneral.countCalls"
                  >
                    <template slot="formatter">
                      {{ formatNumber(animatedGeneral.countCalls) }}
                    </template>
                  </el-statistic>
                </el-card>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-card shadow="hover" class="stat-card">
                  <div slot="header">
                    <span>В статусе "распознано"</span>
                  </div>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-statistic
                          title="Звонков"
                          :value="animatedGeneral.status8Calls"
                      >
                        <template slot="formatter">
                          {{ formatNumber(animatedGeneral.status8Calls) }}
                        </template>
                      </el-statistic>
                    </el-col>
                    <el-col :span="12">
                      <el-statistic
                          title="Минут"
                          :value="animatedGeneral.status8Sec"
                      >
                        <template slot="formatter">
                          {{ formatNumber(animatedGeneral.status8Sec) }}
                        </template>
                      </el-statistic>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col>
                <el-card shadow="hover" class="stat-card">
                  <div slot="header">
                    <span>В статусе "пустое"</span>
                  </div>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-statistic
                          title="Звонков"
                          :value="animatedGeneral.status3Calls"
                          :formatter="formatNumber"
                      >
                        <template slot="formatter">
                          {{ formatNumber(animatedGeneral.status3Calls) }}
                        </template>
                      </el-statistic>
                    </el-col>
                    <el-col :span="12">
                      <el-statistic
                          title="Минут"
                          :value="animatedGeneral.status3Sec"
                          :formatter="formatNumber"
                      >
                        <template slot="formatter">
                          {{ formatNumber(animatedGeneral.status3Sec) }}
                        </template>
                      </el-statistic>

                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </div>

          <div  v-if="callStatData.categories && callStatData.categories.length">
            <h5 style="text-align: center;">Информация по категориям</h5>
            <div style="display: grid; grid-template-columns: 28vw 1fr; gap: 1rem">
              <div>
                <el-tabs
                    v-model="activeCategoryId"
                    type="card"
                    class="category-tabs"
                    tab-position="left"
                    @tab-click="handleCategoryClick"
                >
                  <el-tab-pane
                      v-for="category in callStatData.categories"
                      :key="category.id"
                      :label="category.name"
                      :name="category.id.toString()"
                  >
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div v-if="selectedCategory" class="category-stats">

                <el-row>
                  <el-col>
                    <el-card shadow="hover" class="stat-card">
                      <el-statistic
                          title="Всего минут"
                          :value="animatedCategory.allSec"

                      >
                        <template slot="formatter">
                          {{ formatNumber(animatedCategory.allSec) }}
                        </template>
                      </el-statistic>
                    </el-card>
                  </el-col>
                  <el-col>
                    <el-card shadow="hover" class="stat-card">
                      <el-statistic
                          title="Всего звонков"
                          :value="animatedCategory.countCalls"
                          :formatter="formatNumber"
                      >
                        <template slot="formatter">
                          {{ formatNumber(animatedCategory.countCalls) }}
                        </template>
                      </el-statistic>
                    </el-card>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-card shadow="hover" class="stat-card">
                      <div slot="header">
                        <span>В статусе "распознано"</span>
                      </div>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-statistic
                              title="Звонков"
                              :value="animatedCategory.status8Calls"
                          >
                            <template slot="formatter">
                              {{ formatNumber(animatedCategory.status8Calls) }}
                            </template>
                          </el-statistic>
                        </el-col>
                        <el-col :span="12">
                          <el-statistic
                              title="Минут"
                              :value="animatedCategory.status8Sec"
                          >
                            <template slot="formatter">
                              {{ formatNumber(animatedCategory.status8Sec) }}
                            </template>
                          </el-statistic>
                        </el-col>
                      </el-row>
                    </el-card>
                  </el-col>
                  <el-col>
                    <el-card shadow="hover" class="stat-card">
                      <div slot="header">
                        <span>В статусе "пустое"</span>
                      </div>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-statistic
                              title="Звонков"
                              :value="animatedCategory.status3Calls"
                          >
                          <template slot="formatter">
                            {{ formatNumber(animatedCategory.status3Calls) }}
                          </template>
                          </el-statistic>
                        </el-col>
                        <el-col :span="12">
                          <el-statistic
                              title="Минут"
                              :value="animatedCategory.status3Sec"
                          >
                            <template slot="formatter">
                              {{ formatNumber(animatedCategory.status3Sec) }}
                            </template>
                          </el-statistic>
                        </el-col>
                      </el-row>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import MyDatePeriodPicker from "../newCatigories/myDatePeriodPicker.vue";
import MyButton from "../UI/MyButton.vue";

export default {
  name: "calls-time-stat-block",
  components: {MyButton, MyDatePeriodPicker},
  props: {
    callStatBlockVisible: {
      type: Boolean,
    },
  },
  data() {
    return {
      activeCategoryId: null,
      selectedCategory: null,
      buttonLoading: false,
      startEndDateForCallListAndCategoryDictionaries: {
        start: null,
        end: null
      },
      callStatData: {
        general: null,
        categories: null
      },
      animatedGeneral: {
        allSec: 0,
        countCalls: 0,
        status8Calls: 0,
        status8Sec: 0,
        status3Calls: 0,
        status3Sec: 0
      },
      animatedCategory: {
        allSec: 0,
        countCalls: 0,
        status8Calls: 0,
        status8Sec: 0,
        status3Calls: 0,
        status3Sec: 0
      },
      animationTimers: []
    }
  },
  watch: {
    'callStatData.general': {
      handler(newVal) {
        if (newVal) {
          this.animateGeneralValues(newVal)
        }
      },
      deep: true,
      immediate: false
    },
    'callStatData.categories': {
      handler(newVal) {
        if (newVal && newVal.length) {
          if (!this.activeCategoryId) {
            this.activeCategoryId = newVal[0].id.toString()
            this.setSelectedCategory(newVal[0])
          }
        }
      },
      deep: true,
      immediate: false
    }
  },
  computed: {

  },
  methods: {
    formatNumber(value) {
      return Math.round(value).toLocaleString('ru-RU')
    },

    animateGeneralValues(newData) {
      this.animateValue('animatedGeneral', 'allSec', newData.all_sec || 0)
      this.animateValue('animatedGeneral', 'countCalls', newData.count_calls || 0)
      this.animateValue('animatedGeneral', 'status8Calls', newData.status_8_calls || 0)
      this.animateValue('animatedGeneral', 'status8Sec', newData.status_8_sec || 0)
      this.animateValue('animatedGeneral', 'status3Calls', newData.status_3_calls || 0)
      this.animateValue('animatedGeneral', 'status3Sec', newData.status_3_sec || 0)
    },
    animateCategoryValues(category) {
      if (!category) return
      this.animateValue('animatedCategory', 'allSec', category.all_sec || 0)
      this.animateValue('animatedCategory', 'countCalls', category.count_calls || 0)
      this.animateValue('animatedCategory', 'status8Calls', category.status_8_calls || 0)
      this.animateValue('animatedCategory', 'status8Sec', category.status_8_sec || 0)
      this.animateValue('animatedCategory', 'status3Calls', category.status_3_calls || 0)
      this.animateValue('animatedCategory', 'status3Sec', category.status_3_sec || 0)
    },
    animateValue(objPath, key, targetValue) {
      const duration = 500
      const startTime = Date.now()

      const startValue = this[objPath][key] || 0
      const animate = () => {
        const now = Date.now()
        const progress = Math.min((now - startTime) / duration, 1)
        const easeOutCubic = 1 - Math.pow(1 - progress, 3)
        this[objPath][key] = startValue + (targetValue - startValue) * easeOutCubic
        if (progress < 1) {
          const timerId = requestAnimationFrame(animate)
          this.animationTimers.push(timerId)
        } else {
          this[objPath][key] = targetValue
        }
      }

      const timerId = requestAnimationFrame(animate)
      this.animationTimers.push(timerId)
    },
    handleCategoryClick(tab) {
      const categoryId = parseInt(tab.name)
      const category = this.callStatData.categories.find(c => c.id === categoryId)
      if (category) {
        this.setSelectedCategory(category)
      }
    },
    setSelectedCategory(category) {
      this.selectedCategory = category
      this.resetAnimatedCategory()
      this.$nextTick(() => {
        this.animateCategoryValues(category)
      })
    },

    resetAnimatedCategory() {
      this.animatedCategory = {
        allSec: 0,
        countCalls: 0,
        status8Calls: 0,
        status8Sec: 0,
        status3Calls: 0,
        status3Sec: 0
      }
    },

    getCallsStat() {
      this.buttonLoading = true
      this.$api.general.getCallsStat({
        date_start: this.startEndDateForCallListAndCategoryDictionaries.start,
        date_end: this.startEndDateForCallListAndCategoryDictionaries.end,
      })
          .then(data => {
            this.clearAnimations()

            this.selectedCategory = null
            this.activeCategoryId = null
            this.resetAnimatedCategory()

            this.callStatData = data
          })
          .finally(() => {
            this.buttonLoading = false
          })
    },
    getCallsStatExcel() {
      this.buttonLoading = true;

      this.$api.general.getCallsStatExcel(
          {
            date_start: this.startEndDateForCallListAndCategoryDictionaries.start,
            date_end: this.startEndDateForCallListAndCategoryDictionaries.end,
            render_file: 1,
          },
          { responseType: 'blob' }
      )
          .then(response => {
            const raw = response && response.data;
            if (raw == null) {
              this.$notify.error({ title: 'Ошибка', message: 'Пустой ответ сервера' });
              return;
            }

            let blob;
            if (raw instanceof Blob) {
              blob = raw;
            } else if (raw instanceof ArrayBuffer) {
              blob = new Blob([raw], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            } else if (typeof raw === 'string') {

              const bytes = new Uint8Array(raw.length);
              for (let i = 0; i < raw.length; i++) {
                bytes[i] = raw.charCodeAt(i) & 0xff;
              }
              blob = new Blob([bytes], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              });
            } else {
              console.error('Неизвестный тип ответа:', raw);
              this.$notify.error({ title: 'Ошибка', message: 'Некорректный ответ сервера' });
              return;
            }

            if (!blob.size) {
              this.$notify.info({
                title: 'Нет данных',
                message: 'По выбранным параметрам данные не найдены',
              });
              return;
            }

            const firstChar = raw && typeof raw === 'string' ? raw[0] : '';
            if (firstChar === '{' || firstChar === '[') {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const error = JSON.parse(reader.result);
                  this.$notify.error({
                    title: 'Ошибка',
                    message: error.message || 'Ошибка при генерации файла',
                  });
                } catch (e) {
                  console.error('Не удалось распарсить JSON:', reader.result);
                }
              };
              reader.readAsText(blob);
              return;
            }

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            const date = new Date();
            const fileName = `calls-${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}.xlsx`;

            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            this.$notify.success({
              title: 'Успешно',
              message: 'Файл успешно скачан',
            });
          })
          .catch(err => {
            console.error(err);
            this.$notify.error({ title: 'Ошибка', message: 'Не удалось скачать файл' });
          })
          .finally(() => {
            this.buttonLoading = false;
          });
    },

    getStartEndTimeForGetCategoryCalls(callback) {
      this.startEndDateForCallListAndCategoryDictionaries = callback
    },

    clearAnimations() {
      this.animationTimers.forEach(timer => {
        if (timer) cancelAnimationFrame(timer)
      })
      this.animationTimers = []
    }
  },
  beforeDestroy() {
    this.clearAnimations()
  }
}
</script>

<style scoped lang="scss">

.calls-stats-dialog {
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__body {
    padding-top: 1rem;
    h5 {
      margin-bottom: .5rem;
    }
    .calls-stat-block {
      &__period {
        > div:first-child {
          display: flex;
          justify-content: center;
        }
        >div:last-child {
          display: flex;
          justify-content: center;
          gap:1rem;
          margin-bottom: 1rem;
        }

      }
      &__body {
        display: grid;
        grid-template-columns: 1fr 3fr;
        gap: 1rem;
        height: 55vh;
        > div:first-child {
          .general {
            margin-left: 1rem;
            p {
              color: #24387f;
              margin-bottom: 0.2rem;
            }

          }
        }
        ::v-deep .el-tabs__header.is-left {
          width: 100%;
        }
        ::v-deep .el-tabs--left .el-tabs__item.is-left {
          text-wrap: auto;
        }
        }

    }
  }
}

.calls-stat-block {
  &__period {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;
  }

  &__body {
    padding: 20px 0;
  }
}

.stat-card {
  margin-bottom: 20px;

  ::v-deep .el-card__header {
    background: #f5f7fa;
    font-weight: 600;
    padding: 12px 20px;
  }

  ::v-deep .el-statistic {
    padding: 5px;
    text-align: center;

    &__head {
      color: #606266;
      font-size: 14px;
      margin-bottom: 8px;
    }

    &__content {
      color: #409EFF;
      font-size: 24px;
      font-weight: 600;
    }
  }
}

h5 {
  font-size: 18px;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #409EFF;
}

.category-tabs {
  max-height: 44vh;
  overflow-y: auto;
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
  ::v-deep .el-tabs__item {
    font-size: 14px;
    height: 40px;
    line-height: 40px;
  }
}
.category-stats {
  padding: 20px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

</style>